import { useMemo } from 'react';

/**
 * Вычисляет строку вида «UTC+3» / «UTC+5:30» по текущему часовому поясу браузера.
 * Поддерживает дробные смещения (Индия +5:30, Непал +5:45, и т.д.).
 * Чистая функция — можно вызывать вне React (тултипы, константы, утилиты).
 */
export const getUtcLabel = (): string => {
  const offsetMin = -new Date().getTimezoneOffset();
  const sign = offsetMin >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMin);
  const hours = Math.floor(abs / 60);
  const minutes = abs % 60;
  return minutes === 0
    ? `UTC${sign}${hours}`
    : `UTC${sign}${hours}:${String(minutes).padStart(2, '0')}`;
};

/**
 * React-хук-обёртка над {@link getUtcLabel}.
 * Значение вычисляется один раз при монтировании компонента.
 */
export const useUtcLabel = (): string => useMemo(() => getUtcLabel(), []);
